var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.57 6.3 4.756-4.755a.899.899 0 1 0-1.27-1.27L6.3 5.03 1.545.274a.898.898 0 0 0-1.27 1.27L5.03 6.3.274 11.055a.898.898 0 1 0 1.27 1.27L6.3 7.57l4.755 4.756a.898.898 0 0 0 1.27-1.27z"
  })));
};
export default SvgX;